import { render, staticRenderFns } from "./BuildingIndex.vue?vue&type=template&id=6537d36e&scoped=true"
import script from "./BuildingIndex.vue?vue&type=script&lang=js"
export * from "./BuildingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537d36e",
  null
  
)

export default component.exports